import React from 'react';
import addImage from '../../../assets/images/add-image.png';

function EditForm(props) {

  return (
    <div className="container">
      <div className="columns">
        <div className="column is-12">
          <div className="field">
            <label htmlFor='image' className='is-flex'>
              <figure className="image is-32x32">
                <img className='img' src={addImage} alt='' />
              </figure>
              <span className='title is-size-4'>{props.imgName}</span>
            </label>
            <progress className="progress mt-3" style={{ borderRadius: '4px', marginBottom: 0 }} value={props.progress} max="100" />
            <small className='has-text-danger is-size-7'>*Required</small>
            <input type='file' name='image' id="image" style={{ display: "none" }} onChange={(e) => { props.handleImage(e) }} />
          </div>
          <div className="field" >
            <label htmlFor='topic' className='label mt-3'>Heading</label>
            <input type='text' name='topic' id="topic" className='input' style={{ borderColor: '#7BC8FF', borderWidth: '2px' }} defaultValue={props.data.topic} onChange={(e) => props.handleInput(e)} />
            <small className='has-text-danger is-size-7'>*Required</small>
          </div>
          <div className="field">
            <label htmlFor='body' className='label mt-3'>Body</label>
            <textarea rows='10' name='body' id='body' className="textarea has-fixed-size" style={{ borderColor: '#7BC8FF', borderWidth: '2px' }} defaultValue={props.data.body} onChange={(e) => props.handleInput(e)} />
            <small className='has-text-danger is-size-7'>*Required</small>
          </div>
        </div>
      </div>
      <div className="columns">
        <div className="column is-12 is-flex is-justify-content-center">
          <button className="button btn" onClick={() => { props.handleUpdate() }}>
            <span className="icon">
              <i className="fas fa-wrench"></i>
            </span>
            <span>Update</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default EditForm;